"use strict";
exports.__esModule = true;
var Types_1 = require("./Types");
function IndexOfFirstPropertyMatch(properties, testProperties, testPropertiesStartIndex) {
    if (testPropertiesStartIndex === void 0) { testPropertiesStartIndex = 0; }
    for (var i = testPropertiesStartIndex; i < testProperties.length; i++) {
        var flagToTest = testProperties[i];
        if ((properties & flagToTest) === flagToTest) {
            return i;
        }
    }
    return -1;
}
function ContainsMultipleMatches(properties, propertiesToMatch) {
    var firstMatchIndex = IndexOfFirstPropertyMatch(properties, propertiesToMatch);
    if (firstMatchIndex !== -1) {
        return (IndexOfFirstPropertyMatch(properties, propertiesToMatch, firstMatchIndex + 1) !== -1);
    }
    return false;
}
function HasMultipleErrorLevels(properties) {
    var errorLevelProperties = [
        Types_1.GtlErrorProperties.ErrorLevel_Warning,
        Types_1.GtlErrorProperties.ErrorLevel_Verbose,
        Types_1.GtlErrorProperties.ErrorLevel_Fatal,
        Types_1.GtlErrorProperties.ErrorLevel_ScenarioBlocking
    ];
    return ContainsMultipleMatches(properties, errorLevelProperties);
}
exports.HasMultipleErrorLevels = HasMultipleErrorLevels;
function HasMultipleErrorTypes(properties) {
    var errorTypeProperties = [
        Types_1.GtlErrorProperties.ErrorCode_Type_HRESULT,
        Types_1.GtlErrorProperties.ErrorCode_Type_Win32,
        Types_1.GtlErrorProperties.ErrorCode_Type_NTSTATUS,
        Types_1.GtlErrorProperties.ErrorCode_Type_HTTP
    ];
    return ContainsMultipleMatches(properties, errorTypeProperties);
}
exports.HasMultipleErrorTypes = HasMultipleErrorTypes;
function IsUserFacingError(properties) {
    var userFacingProperties = [
        Types_1.GtlErrorProperties.UserResolvable,
        Types_1.GtlErrorProperties.UserVisible
    ];
    return IndexOfFirstPropertyMatch(properties, userFacingProperties) !== -1;
}
exports.IsUserFacingError = IsUserFacingError;
//# sourceMappingURL=ErrorPropertyHelpers.js.map